import { Info } from '@griply/assets';
import React, { useRef } from 'react';
import { Icon } from 'shared/components/ui/icon';
import { Tooltip } from 'shared/components/ui/tooltip';

import * as Styled from './info-icon.style';

export type InfoIconProps = {
  label: string;
};

// A hover affordance, never a tab stop — Tab stays on the field it annotates.
export const InfoIcon: React.FC<InfoIconProps> = ({ label }) => {
  const infoRef = useRef<HTMLButtonElement>(null);

  return (
    <>
      <Styled.InfoButton type="button" tabIndex={-1} ref={infoRef}>
        <Icon icon={Info} aria-label={label} />
      </Styled.InfoButton>
      <Tooltip referenceElement={infoRef} label={label} />
    </>
  );
};
